var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('email-templates-index',{attrs:{"fields":_vm.fields,"filters":_vm.filters,"query":_vm.query}})
}
var staticRenderFns = []

export { render, staticRenderFns }